import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
export const handleInitialInterestError = (error = {}) => {
  const LOG = Logger.getLogger('handleSurveySubmissionResponse');
  LOG.error('Initial Interest failed.', {
    extra: getSentryExtra(error)
  });
};